export default "__VITE_ASSET__BKPktUtd__"